export const UPDATE_QRCODE_HEADER_TEXT = 'qrcode.UPDATE_QRCODE_HEADER_TEXT';